import { BuiltinInterface } from '../BuiltinInterface';
import { BuiltinValueObject } from '../BuiltinValueObject';
class RegExpInterface extends BuiltinInterface {
}
class RegExpValue extends BuiltinValueObject {
    constructor() {
        super(...arguments);
        this.type = 'RegExpConstructor';
    }
}
class RegExpConstructorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addInterface('RegExp', new RegExpInterface());
    builtins.addValue('RegExp', new RegExpValue());
    builtins.addInterface('RegExpConstructor', new RegExpConstructorInterface());
};

//# sourceMappingURL=index.js.map
